import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  Container,
  Divider,
  useTheme,
  IconButton,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useState } from 'react';
import { ExpandMore, Help, Description, QuestionAnswer, Home } from '@mui/icons-material';
import { tokens } from '../../theme';
import { useNavigate } from 'react-router-dom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`help-tabpanel-${index}`}
      aria-labelledby={`help-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `help-tab-${index}`,
    'aria-controls': `help-tabpanel-${index}`,
  };
}

// Componente dos Termos e Condições
function TermsContent() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        backgroundColor: colors.primary[400],
        border: `1px solid ${colors.grey[700]}`,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: colors.greenAccent[400],
          fontWeight: 'bold',
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Description />
        Termos e Condições de Uso
      </Typography>

      <Typography sx={{ color: colors.grey[100], mb: 2 }}>
        REDUTO CAPITAL SERVIÇOS EM TI LTDA., pessoa jurídica de direito privado, inscrita no CNPJ
        sob o nº 49.595.503/0001-46, com sede na Avenida Presidente Vargas, nº 2.921, Sala 402, Vila
        Homero, Indaiatuba/SP, CEP 13338-705, doravante denominada "REDUTO", estabelece, por meio
        deste instrumento, as condições para o acesso e uso da plataforma REDSCORE PLUS pelo
        CLIENTE, conforme as cláusulas e condições a seguir:
      </Typography>

      <Typography
        sx={{
          color: colors.grey[100],
          textAlign: 'justify',
          lineHeight: 1.7,
          fontSize: '1rem',
        }}
      >
        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            1. OBJETO
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            1.1. O presente Termo regula o acesso à plataforma REDSCORE PLUS e a utilização, pelo
            CLIENTE, dos dados e informações ali disponibilizados, cuja finalidade se limita à
            análise de risco de crédito e risco socioambiental, no contexto de suas relações
            empresariais.
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            1.2. O uso da plataforma pelo CLIENTE implica adesão plena, irretratável e vinculante às
            condições aqui previstas, observados os princípios da boa-fé e da função social do
            contrato.
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            2. OBRIGAÇÕES DO CLIENTE
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            2.1. Constituem obrigações essenciais do CLIENTE:
          </Typography>
          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>
              a) Utilizar a plataforma exclusivamente para os fins definidos neste instrumento;
            </li>
            <li>
              b) Garantir a confidencialidade das informações acessadas, vedando sua divulgação,
              repasse ou utilização por terceiros;
            </li>
            <li>
              c) Implementar medidas técnicas e organizacionais apropriadas à proteção dos dados
              acessados;
            </li>
            <li>
              d) Observar integralmente a legislação vigente, notadamente a Lei Geral de Proteção de
              Dados Pessoais (Lei nº 13.709/2018);
            </li>
            <li>
              e) Eliminar todos os dados acessados após o encerramento do vínculo com a REDUTO,
              mediante comprovação documental, se solicitado.
            </li>
          </Box>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            3. DO USO DA PLATAFORMA E PROPRIEDADE INTELECTUAL
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 1 }}>
            3.1. A plataforma REDSCORE PLUS e seus componentes (códigos-fonte, estrutura lógica,
            interface, algoritmos, fluxos e bancos de dados) são de propriedade exclusiva da REDUTO,
            estando protegidos por direitos de propriedade intelectual e industrial, nos termos da
            Lei nº 9.279/1996 e legislação correlata.
          </Typography>

          <Typography sx={{ color: colors.grey[100], mb: 1 }}>
            3.2. É expressamento vetado ao CLIENTE:
          </Typography>

          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>
              a) Reproduzir, modificar, sublicenciar, comercializar ou explorar qualquer conteúdo da
              plataforma;
            </li>
            <li>b) Integrar os dados acessados a sistemas, produtos ou bancos de terceiros.</li>
          </Box>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            4. DO TRATAMENTO DE DADOS PESSOAIS
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            4.1. O CLIENTE declara ter ciência e concordar que a REDUTO poderá coletar, tratar,
            armazenar e utilizar dados pessoais e cadastrais fornecidos no âmbito da presente
            relação contratual, exclusivamente para fins de autenticação, auditoria, prevenção a
            fraudes, segurança da informação, suporte técnico, gestão de acesso e cumprimento de
            obrigações legais.
          </Typography>

          <Typography sx={{ color: colors.grey[100], mb: 1 }}>
            4.2. O CLIENTE reconhece, ainda:
          </Typography>

          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>
              a) Que poderá exercer, a qualquer tempo, os direitos previstos nos arts. 18 e
              seguintes da LGPD;
            </li>
            <li>
              b) Que os dados serão tratados em conformidade com os princípios da finalidade,
              necessidade, transparência e segurança;
            </li>
            <li>
              c) Que a REDUTO poderá manter registros de logs e acessos para fins de conformidade,
              controle e auditoria.
            </li>
          </Box>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            5. DAS RESPONSABILIDADE E PENALIDADES
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            5.1. O CLIENTE poderá ser responsabilizado em caso de descumprimento comprovado das
            normas previstas neste termo, inclusive mediante a obrigação de indenizar a REDUTO e
            terceiros pelos danos causados, proporcionalmente ao prejuízo apurado.
          </Typography>

          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            5.2. O descumprimento de qualquer cláusula poderá, ainda, ensejar:
          </Typography>

          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>
              a) A suspensão imediata ou temporária do acesso do CLIENTE à plataforma, com prévia
              notificação, salvo em situações de risco à integridade da plataforma ou à legislação
              vigente.
            </li>
          </Box>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            6. DA LIMITAÇÃO DE RESPONSABILIDADE DA REDUTO
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            6.1. A REDUTO fornece informações que auxiliam a tomada de decisão de crédito, cabendo
            ao CLIENTE a análise e responsabilidade final por suas decisões.
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            6.2. A REDUTO não se responsabiliza por:
          </Typography>
          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>
              a) Interrupções momentâneas na prestação dos serviços por caso fortuito, força maior
              ou manutenção técnica;
            </li>
            <li>
              b) Decisões comerciais ou jurídicas tomadas pelo CLIENTE com base nas informações
              fornecidas pela plataforma;
            </li>
            <li>
              c) Atos ou omissões de terceiros não contratados ou não controlados pela REDUTO.
            </li>
          </Box>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            7. DAS SEGURANÇAS E CONDUTAS PROIBIDAS
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            7.1. O CLIENTE obriga-se a não praticar, direta ou indiretamente:
          </Typography>

          <Box component="ul" sx={{ color: colors.grey[100], ml: 2 }}>
            <li>a) Tentativas de violação da segurança da plataforma;</li>
            <li>
              b) Uso de identidades falsas, contas automatizadas ou criação de perfis para fins
              fraudulentos;
            </li>
            <li>
              c) Inserção de códigos maliciosos, scripts ou qualquer forma de interferência no
              sistema.
            </li>
          </Box>

          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            7.2. A senha de acesso é pessoal e intransferível. O compartilhamento não autorizado
            poderá resultar em suspensão do acesso ou outras medidas, conforme a gravidade do caso;
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            8. DO ACEITE ELETRÔNICO
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            8.1. O aceite eletrônico do presente Termo por meio de login, assinatura digital, clique
            de concordância ou outro mecanismo válido configura manifestação de vontade expressa,
            com eficácia jurídica plena nos termos da MP nº 2.200-2/2001 e do Código Civil.
          </Typography>

          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            8.2. A REDUTO poderá revisar este Termo a qualquer tempo, mediante comunicação ao
            CLIENTE. A continuidade do uso da plataforma após a atualização implicará aceitação
            tácita das novas condições.
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            9. DA VIGÊNCIA E RECISÃO
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            9.1. Este Termo entra em vigor na data de seu aceite eletrônico e permanecerá válido
            enquanto o CLIENTE mantiver vínculo ativo com a REDUTO ou utilizar a plataforma REDSCORE
            PLUS.
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            9.2. A REDUTO poderá rescindir este instrumento unilateralmente, com efeitos imediatos,
            em caso de violação de qualquer das cláusulas aqui pactuadas.
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            10. CONTATO E SUPORTE
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            10.1. As notificações, correspondências, pedido de informações ou qualquer outro motivo
            deverão ser encaminhadas por meio de e-mail, no endereço: cadastro@redutocapital.com.br.
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            11. DO FORO
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            11.1. Fica eleito o foro da Comarca de Indaiatuba/SP, com renúncia expressa a qualquer
            outro, por mais privilegiado que seja, para dirimir eventuais controvérsias oriundas
            deste Termo.
          </Typography>
        </Box>

        <Box component="div" sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: 'bold', mb: 2 }}
          >
            TERMO DE ACEITE
          </Typography>
          <Typography sx={{ color: colors.grey[100], mb: 2 }}>
            Declaro, para os devidos fins, que li integralmente o conteúdo do Termo de Aceite e
            Responsabilidade, compreendi todas as suas cláusulas e reconheço a importância da
            leitura integral deste documento antes do uso da plataforma, aceitando seus efeitos
            jurídicos, nos termos da MP nº 2.200-2/2001 e do Código Civil Brasileiro.
          </Typography>
        </Box>

        <Divider sx={{ my: 3, backgroundColor: colors.grey[700] }} />

        <Typography
          variant="body2"
          sx={{
            color: colors.grey[300],
            fontStyle: 'italic',
            textAlign: 'center',
          }}
        >
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </Typography>
      </Typography>
    </Paper>
  );
}

// Componente do FAQ
function FAQContent() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const faqData = [
    {
      category: 'Primeiros Passos',
      questions: [
        {
          question: 'O que é o REDSCORE?',
          answer:
            'O REDSCORE é um sistema de pontuação de crédito voltado exclusivamente para o agronegócio. Ele combina dados da Serasa (Agro Score PJ) com algoritmos proprietários da Reduto, para indicar a probabilidade de inadimplência de um cliente (pessoa física ou jurídica) rural.',
        },
        {
          question: 'Como funciona o score e o que os números significam?',
          answer:
            'O score vai de 0 a 1.000, sendo que: quanto maior o score, menor o risco de inadimplência; as faixas seguem a escala do Serasa Agro Score com base em modelos de 6M, 12M e 18M (inadimplência com atraso de 60, 90 e 180 dias).',
        },
      ],
    },
    {
      category: 'Funcionalidades',
      questions: [
        {
          question: 'Como faço uma consulta de CPF ou CNPJ?',
          answer:
            'Acesse o menu “Consultar”, informe o CPF ou CNPJ do produtor rural e clique em “Buscar”. O sistema exibirá o score agro, dados cadastrais, restrições financeiras e histórcio rural (se houver).',
        },
        {
          question: 'Onde vejo meu histórico de consultas?',
          answer:
            'No menu “Histórico” você verá a lista de todas as consultas realizadas. Você pode salvar em PDF ou imprimir para anexar no seu processo de crédito.',
        },
        {
          question: 'O que significa quando não há score disponível para um CPF/CNPJ?',
          answer:
            'Pode ocorrer por motivos como: cadastro recém aberto ou com pouca movimentação; falta de dados agro relevantes no histórico, CNPJ baixado, inapto ou irregular na Receita Federal.',
        },
      ],
    },
    {
      category: 'Sobre as consultas',
      questions: [
        {
          question: 'Quantas consultas posso fazer por mês?',
          answer:
            'Você pode usar os créditos adquiridos livremente, sem limite mensal. Cada CPF ou CNPJ consultado consome 1 crédito.',
        },
        {
          question: 'As consultas notificam o cliente final?',
          answer:
            'Não. As consultas são feitas em ambiente restrito, seguindo a LGPD, e não geram notificações para o consultado.',
        },
      ],
    },
    {
      category: 'Conta e Pagamento',
      questions: [
        {
          question: 'A plataforma cobra mensalidade?',
          answer:
            'Não! O único valor cobrado dentro da plataforma é a compra de cŕeditos para consulta de CPF e CNPJ de produtores rurais. Esses créditos são pré-pagos e sem prazo de validade. Não há cobrança recorrente e nem contrato de fidelidade.',
        },
        {
          question: 'Como faço para comprar créditos?',
          answer:
            'Vá até o menu “Recarregar”, escolha o pacote de créditos desejado (ex: 10, 250, 500) e finalize o pagamento. Os créditos são ativados imediatamente após a confirmação.',
        },
      ],
    },
    {
      category: 'Segurança e Privacidade',
      questions: [
        {
          question: 'Meus dados estão seguros na plataforma?',
          answer:
            'Sim! Utilizamos criptografia de ponta a ponta e seguimos as melhores práticas de segurança. Todos os dados são armazenados em servidores seguros.',
        },
        {
          question: 'Vocês compartilham meus dados com terceiros?',
          answer:
            'Não. Seus dados são de sua propriedade exclusiva. Não compartilhamos, vendemos ou cedemos informações para terceiros, exceto quando exigido por lei ou com seu consentimento explícito.',
        },
        {
          question: 'Como posso deletar permanentemente meus dados?',
          answer:
            'Entre em contato com nosso suporte solicitando a exclusão completa dos dados. O processo será concluído em até 15 dias úteis, conforme previsto na LGPD.',
        },
      ],
    },
    {
      category: 'Suporte Técnico',
      questions: [
        {
          question: 'Como entro em contato com o suporte?',
          answer:
            'Você pode nos contatar via e-mail (suporte@redutocapital.com.br) ou Whatsapp ((19) 99950-5191).',
        },
        {
          question: 'Qual o tempo de resposta do suporte?',
          answer:
            'E-mail: até 4 horas durante dias úteis. Para questões urgentes, recomendamos usar o Whatsapp.',
        },
      ],
    },
  ];

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          color: colors.greenAccent[400],
          fontWeight: 'bold',
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <QuestionAnswer />
        Perguntas Frequentes
      </Typography>

      {faqData.map((category, categoryIndex) => (
        <Box key={categoryIndex} sx={{ mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              color: colors.grey[100],
              fontWeight: 'bold',
              mb: 2,
              borderBottom: `2px solid ${colors.greenAccent[400]}`,
              pb: 1,
            }}
          >
            {category.category}
          </Typography>

          {category.questions.map((faq, faqIndex) => (
            <Accordion
              key={faqIndex}
              sx={{
                backgroundColor: colors.primary[400],
                border: `1px solid ${colors.grey[700]}`,
                mb: 1,
                '&:before': {
                  display: 'none',
                },
                '&.Mui-expanded': {
                  margin: '0 0 8px 0',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: colors.greenAccent[400] }} />}
                sx={{
                  backgroundColor:
                    theme.palette.mode === 'dark' ? colors.primary[500] : colors.white,
                  '&.Mui-expanded': {
                    backgroundColor:
                      theme.palette.mode === 'dark' ? colors.primary[600] : colors.white,
                  },
                }}
              >
                <Typography
                  sx={{
                    color: colors.grey[100],
                    fontWeight: 'medium',
                    fontSize: '1.1rem',
                  }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  backgroundColor: colors.primary[400],
                  borderTop: `1px solid ${colors.grey[700]}`,
                }}
              >
                <Typography
                  sx={{
                    color: colors.grey[200],
                    lineHeight: 1.6,
                    textAlign: 'justify',
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      ))}
    </Box>
  );
}

// Componente principal da página de ajuda
export default function HelpPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3, color: colors.grey[300] }}>
        <Link
          component="button"
          onClick={() => navigate("/app/dashboard")}
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: colors.greenAccent[400],
            textDecoration: 'none',
            '&:hover': {
              color: colors.greenAccent[300],
            },
          }}
        >
          <Home sx={{ mr: 0.5, fontSize: 20 }} />
          Dashboard
        </Link>
        <Typography sx={{ color: colors.grey[100] }}>Ajuda</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 4,
          p: 3,
          backgroundColor: colors.primary[400],
          borderRadius: 2,
          border: `1px solid ${colors.grey[700]}`,
        }}
      >
        <Help
          sx={{
            fontSize: 40,
            color: colors.greenAccent[400],
            mr: 2,
          }}
        />
        <Box>
          <Typography
            variant="h3"
            sx={{
              color: colors.greenAccent[400],
              fontWeight: 'bold',
              mb: 1,
            }}
          >
            Central de Ajuda
          </Typography>
          <Typography variant="subtitle1" sx={{ color: colors.grey[200] }}>
            Encontre respostas para suas dúvidas e acesse nossos termos de uso
          </Typography>
        </Box>
      </Box>

      {/* Tabs */}
      <Paper
        elevation={3}
        sx={{
          backgroundColor: colors.primary[400],
          border: `1px solid ${colors.grey[700]}`,
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="help tabs"
          sx={{
            borderBottom: `1px solid ${colors.grey[700]}`,
            '& .MuiTab-root': {
              color: colors.grey[300],
              fontSize: '1rem',
              fontWeight: 'medium',
              textTransform: 'none',
              minHeight: 60,
            },
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[400],
            },
            '& .MuiTabs-indicator': {
              backgroundColor: colors.greenAccent[500],
              height: 3,
            },
          }}
        >
          <Tab
            icon={<QuestionAnswer />}
            iconPosition="start"
            label="Perguntas Frequentes"
            {...a11yProps(0)}
          />
          <Tab
            icon={<Description />}
            iconPosition="start"
            label="Termos e Condições"
            {...a11yProps(1)}
          />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <FAQContent />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <TermsContent />
        </TabPanel>
      </Paper>
    </Container>
  );
}
